import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-global-menu',
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatIconModule, MatTooltipModule, CommonModule, RouterModule],
  templateUrl: './global-menu.component.html',
  styleUrl: './global-menu.component.scss'
})
export class GlobalMenuComponent {
  constructor(
    public route: Router,
    public utilities: UtilitiesService
  ) { }


  createNewClient() {
    this.route.navigate(['/global', 'new-client']);
  }

  createNewAcquirer() {
    this.route.navigate(['/global', 'new-acquirer']);
  }
}


